import React from "react";
import MembershipInformation from "./membershipCard";
import BillingInformation from "./billingCard";
import CreditCardInformation from "./creditCardInfo";
import TransactionSummary from "./transaction";
import PurchasedBooks from "./purchasedBooks";


const Index = () => {
    return (
        <div className="accountWrapper">
            <div className="innerWrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="titleSection">
                                <h5 className="topTitle">My Account</h5>
                                <h3 className="mainTitle">Account Information</h3>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="leftSection">
                                <MembershipInformation />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="rightSection">
                                <BillingInformation />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="bottomSection">
                                <CreditCardInformation />
                                <TransactionSummary />
                                <PurchasedBooks />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;